import { Datipreventivo } from "../model/datipreventivo";
import { Lead } from "../model/lead";

export class DatiRisparmio {
    public static dati(): Datipreventivo {
        return {
            id_comodity: 2,
            lead: new Lead(),
            component:null,
            datiextra: [
                {
                    idDato: 1,
                    tipodato: 1, //string
                    lstopzione: [],
                    descrizione: "consumo annuo gas",
                    valore: "0"
                },
                {
                    idDato: 2,
                    tipodato: 2, //list
                    lstopzione: [
                        {
                            value: "Non Residente",
                            des: "Non Residente",
                            urlfoto: ""
                        },
                        {
                            value: "Residente",
                            des: "Residente",
                            urlfoto: ""
                        },

                    ],
                    descrizione: "Tipologia di residenza",
                    valore: "0"
                },
                // {
                //     tipodato:1, //string
                //     lstopzione:[],
                //     descrizione:"Cabina remi",
                //     valore:"0"
                // },
            ]

        };
    }
}




// WEBPACK FOOTER //
// ./src/app/archiviodatipreventivo/dati-risparmio.ts